var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-info-component", {
    attrs: {
      title: _vm.$t("pages.planning.widgets.hour_balance"),
      value: _vm.hourBalance,
      "is-loading": !_vm.userData,
      icon: "fa-clock",
      tone: "teal",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }